import { onlineStatusInstance, checkDocument } from '../../customLib';

export const initOnlineCheck = {
	isOnline: checkDocument() ? navigator.onLine : true,
	offlineOutTime: Date.now(),
};

export const onlineCheckActions = store => {
	const onlineOrNot = type => {
		if (checkDocument()) {
			const { offlineOutTime } = store.getState();

			store.setState({
				isOnline: type === 'online',
				offlineOutTime: type === 'online' ? offlineOutTime : Date.now(),
			});
		}
	};

	return {
		/**
		 * Online Check:
		 */
		__onlineCheckStart: () => {
			onlineStatusInstance.onOnline(onlineOrNot);
			onlineStatusInstance.onOffline(onlineOrNot);
		},
		__onlineCheckEnd: () => {
			onlineStatusInstance.resetAll();
		},
	};
};
